export default function UsuariosAtivos() {
  return (
    <div className="bg-white rounded-xl p-4 shadow text-center">
      <h3 className="font-semibold text-gray-700">Usuários Ativos</h3>
      <p className="text-2xl font-bold text-purple-600">1.2K</p>
      <p className="text-sm text-gray-500">Na sua região</p>
    </div>
  );
}